import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_get_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { report_id: string, module_id: string }): Promise<{ report?: $frontendTypes.Notifications.i_report_metadata }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.report_id)) {
      $missingRequiredInParams.push('\'report_id\'');
    }
    if (isNil($inParams.module_id)) {
      $missingRequiredInParams.push('\'module_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

